import { isNil } from 'lodash'

import { auditSupplyDemandApi } from '@eastcoal/api/trade/supplyDemandOperation/auditSupplyDemand'
import { querySupplyDemandApi } from '@eastcoal/api/trade/supplyDemandOperation/querySupplyDemand'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'
import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { SaveButton } from '@eastcoal/formily/components/CrudForm/shared/SaveButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { Select } from '@eastcoal/formily/components/Select'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { useNavigate } from '@eastcoal/router/exports/react-router'
import { SupplyDemandStatus } from '@eastcoal/shared/enums/SupplyDemandStatus'
import { SupplyDemandType } from '@eastcoal/shared/enums/SupplyDemandType'

import { RoleUserSelect } from '../../../../@formily/RoleUserSelect'
import { concatField } from '../constants/fields'

import {
  SupplyDemandFormExposedProps,
  SupplyDemandFormProps
} from './interface'

const schema: SupplyDemandFormProps['schema'] = [
  {
    name: 'type',
    title: '供需类型',
    type: 'number',
    enum: [
      {
        label: '供应',
        value: SupplyDemandType.SUPPLY
      },
      {
        label: '需求',
        value: SupplyDemandType.DEMAND
      }
    ],
    'x-component': Select,
    'x-decorator': FormItem
  },
  {
    name: 'memberName',
    title: '会员名',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  {
    name: 'telephone',
    title: '联系电话',
    type: 'string',
    'x-component': Input,
    'x-decorator': FormItem
  },
  {
    name: 'content',
    title: '详细内容',
    type: 'string',
    'x-component': TextArea,
    'x-decorator': FormItem
  },
  {
    name: concatField,
    title: '业务联系',
    type: 'object',
    'x-component': RoleUserSelect,
    'x-component-props': {
      // 需要 客户经理、品种经理、部门经理 的角色编码
      roleCodes: ['CUSTMANAGER', 'KINDMANAGER', 'DEPTMANAGER']
    },
    'x-decorator': FormItem
  }
]

const readApi: SupplyDemandFormProps['readApi'] = ({ id }) => {
  return {
    api: () => querySupplyDemandApi({ id }),
    ready: !isNil(id)
  }
}
const updateApi: SupplyDemandFormProps['updateApi'] = (values, context) => {
  return auditSupplyDemandApi({
    ...values,
    status:
      context.submitType === SubmitType.SUBMIT
        ? SupplyDemandStatus.AUDIT_SUCCESS
        : values.status
  })
}

export const SupplyDemandForm = ({ mode }: SupplyDemandFormExposedProps) => {
  const { hasApproved } = useUrlParams()
  const navigate = useNavigate()
  return (
    <PageContainer>
      <CrudForm
        mode={mode}
        name='supplyDemandForm'
        readApi={readApi}
        schema={schema}
        updateApi={updateApi}
        actions={[
          <BackButton key='backButton' />,
          <SaveButton key='saveButton' />,
          hasApproved === 'false' && (
            <SubmitButton key='sumbitButton'>审核通过</SubmitButton>
          )
        ]}
        layout={{
          wrapperWidth: 400
        }}
        onSuccess={() => {
          navigate(-1)
        }}
      />
    </PageContainer>
  )
}
